import { render, staticRenderFns } from "./Disability.vue?vue&type=template&id=3cd74860"
import script from "./Disability.vue?vue&type=script&lang=js"
export * from "./Disability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports